<div
  *ngIf="showDonut"
  class="ib"
  (click)="clickHandler($event, tag.tagId)"
  (keydown)="keydownHandler($event, tag.tagId)"
  [attr.tabindex]="tabIndex"
  [attr.role]="role"
  [attr.aria-label]="ariaLabel"
  [ngbTooltip]="tooltip"
  [container]="'body'"
  [disableTooltip]="!showDonut"
>
  <dgx-tag-rating-donut
    class="ib"
    size="sm"
    [level]="level"
    [certified]="!!level"
    [showDefaultPlus]="false"
    [isOwner]="isOwner"
    [showLock]="showLock"
  ></dgx-tag-rating-donut>
</div>
